import PlayArrow from '@mui/icons-material/PlayArrow'
import Schedule from '@mui/icons-material/Schedule'
import Autorenew from '@mui/icons-material/Autorenew'
import SecDimButton from '../../shared/SecDimButton/SecDimButton'
import Tooltip from '../../shared/Tooltip/Tooltip'
import { RegenerateSubscribeTooltip, safeCtaHref } from './drSecDimConfig'
import * as Styled from './DrSecDimStyles'

interface DrSecDimRecommendationProps {
	recommendation: Recommendation
	selectedCount: number
	disabled: boolean
	canRegenerate: boolean
	onRegenerateControlClick: () => void
}

function DrSecDimRecommendation({
	recommendation,
	selectedCount,
	disabled,
	canRegenerate,
	onRegenerateControlClick,
}: DrSecDimRecommendationProps) {
	const { title, justification, ctaHref, ctaLabel, dueInDays } = recommendation
	const hasSelection = selectedCount > 0
	const regenLabel = hasSelection ? `Replace Selected ${selectedCount}` : 'Regenerate All'
	const isBlocked = disabled || !canRegenerate
	const tooltipTitle = canRegenerate ? '' : <RegenerateSubscribeTooltip />

	const handleNavigate = () => {
		const target = safeCtaHref(ctaHref, window.location.origin)
		if (target) window.location.assign(target)
	}

	return (
		<Styled.RecommendationBox data-tour='dr-secdim-recommendation'>
			<Styled.RecommendationHeaderRow>
				<Styled.SectionLabel sx={{ marginBottom: 0 }}>
					Recommended next
				</Styled.SectionLabel>
				<Tooltip
					title={tooltipTitle}
					placement='top'
					disableHoverListener={canRegenerate}
					disableFocusListener={canRegenerate}
					disableTouchListener={canRegenerate}
				>
					<Styled.RegenControl
						type='button'
						data-tour='dr-secdim-regenerate'
						aria-label={regenLabel}
						aria-disabled={isBlocked ? 'true' : undefined}
						onClick={() => {
							if (!isBlocked) onRegenerateControlClick()
						}}
					>
						<Styled.RegenControlLabel>{regenLabel}</Styled.RegenControlLabel>
						<Autorenew />
					</Styled.RegenControl>
				</Tooltip>
			</Styled.RecommendationHeaderRow>
			{dueInDays !== undefined && (
				<Styled.DueChip>
					<Schedule />
					Suggested: within {dueInDays} {dueInDays === 1 ? 'day' : 'days'}
				</Styled.DueChip>
			)}
			<Styled.RecTitle>{title}</Styled.RecTitle>
			<Styled.RecJustification>{justification}</Styled.RecJustification>
			<Styled.RecActionRow>
				<SecDimButton
					rounded
					sx={Styled.REC_PLAY_BUTTON_SX}
					onClick={handleNavigate}
				>
					<Styled.ButtonContent>
						<PlayArrow />
						<Styled.ButtonLabel>{ctaLabel}</Styled.ButtonLabel>
						<Styled.VisuallyHidden> to {title}</Styled.VisuallyHidden>
					</Styled.ButtonContent>
				</SecDimButton>
			</Styled.RecActionRow>
		</Styled.RecommendationBox>
	)
}

export default DrSecDimRecommendation
